import angular from 'angular';

import { fetchPrivilegeDisplayTypesDictionary } from 'app/actions/dictionaries/privilege-display-types-dictionary.actions';
import { changePageTitle } from 'auth/actions/session.actions';

export default angular.module('privilege-templates-routing', []).config([
  '$stateProvider',
  function configure($stateProvider) {
    $stateProvider
      .state('privilegeTemplates-lotteryView', {
        parent: 'arw',
        url: '/privilege-templates-lottery',
        restKey: 'privileges',
        template: '<privilege-templates user-class="ADMIN"></privilege-templates>',
        redirectTo: 'permissions-denied',
        params: {
          skipDirtyForms: false,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Admin Roles')));
            },
          ],
        },
        resolve: {
          api: [
            '$ngRedux',
            'appApi',
            ($ngRedux) =>
              Promise.all([$ngRedux.dispatch(fetchPrivilegeDisplayTypesDictionary())])
                .then(() => ({}))
                // eslint-disable-next-line no-console
                .catch((err) => console.error(err)),
          ],
        },
      })
      .state('privilegeTemplates-retailerViewSecondary', {
        parent: 'arw',
        url: '/privilege-templates-retailer-secondary',
        restKey: 'privileges',
        template: '<privilege-templates user-class="RETAILER_SECONDARY"></privilege-templates>',
        redirectTo: 'permissions-denied',
        params: {
          skipDirtyForms: false,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Secondary Retailer Roles')));
            },
          ],
        },
        resolve: {
          api: [
            '$ngRedux',
            'appApi',
            ($ngRedux) =>
              Promise.all([$ngRedux.dispatch(fetchPrivilegeDisplayTypesDictionary())])
                .then(() => ({}))
                // eslint-disable-next-line no-console
                .catch((err) => console.error(err)),
          ],
        },
      })
      .state('privilegeTemplates-retailerViewPrimary', {
        parent: 'arw',
        url: '/privilege-templates-retailer-primary',
        restKey: 'privileges',
        template: '<privilege-templates user-class="RETAILER_PRIMARY"></privilege-templates>',
        redirectTo: 'permissions-denied',
        params: {
          skipDirtyForms: false,
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Primary Retailer Roles')));
            },
          ],
        },
        resolve: {
          api: [
            '$ngRedux',
            'appApi',
            ($ngRedux) =>
              Promise.all([$ngRedux.dispatch(fetchPrivilegeDisplayTypesDictionary())])
                .then(() => ({}))
                // eslint-disable-next-line no-console
                .catch((err) => console.error(err)),
          ],
        },
      });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/privilege-templates-routing-module.js